<template>
  <div class="relate-order">
    <!-- 关联改签单 -->
    <van-row
      class="refund-list"
      v-for="order in changeList"
      :key="order.changeId"
    >
      <van-col :span="2">
        <van-tag type="success">
          改
        </van-tag>
      </van-col>
      <van-col :span="22">
        <div>
          {{ order.newFromStationName }} → {{ order.newToStationName }}
          <span class="fr font12 main-color">{{ order.changeStatusName }}</span>
        </div>
        <div>
          {{ order.newFromDate }} &nbsp;{{ order.newFromTime }} &nbsp;出发 | {{ order.newTrainCode }}
        </div>
        <div>
          {{ order.psgList[0].passengerName }} &nbsp;({{ order.psgList[0].idCode }})
          <span class="fr">应付：<span class="orange">￥{{ order.changeAmount }}</span></span>
        </div>
      </van-col>
    </van-row>

    <!-- 关联退票单 -->
    <van-row
      class="refund-list"
      v-for="order in refundList"
      :key="order.id"
    >
      <van-col :span="2">
        <van-tag type="danger">
          退
        </van-tag>
      </van-col>
      <van-col :span="22">
        <div>
          {{ order.fromStationName }} → {{ order.toStationName }}
          <span class="fr font12 main-color">{{ order.refundStatusDesc }}</span>
        </div>
        <div>
          {{ order.fromDate }} &nbsp;{{ order.fromTime }} &nbsp;出发 | {{ order.trainCode }}
        </div>
        <div>
          {{ order.passenger.passengerName }} &nbsp;
          （{{ order.passenger.idCode? order.passenger.idCode.replace(/^(.{4})(?:\w+)(.{4})$/,
                                                                     "\$1******\$2") : "" }})
          <span class="fr">应退：<span class="orange">￥{{ order.cuRefundAmount }}</span></span>
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
/**
 * 火车票正常单 查关联的 退改单
 */
import { Tag } from 'vant'

import TrainOrderInteractor from 'Domain/use-cases/train-order-interactor'

export default {
  components: {
    [Tag.name]: Tag
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      changeList: [],
      refundList: []
    }
  },
  created() {
    this.getAlterList()
    this.getRefundList()
  },
  methods: {
    async getAlterList() {
      const { data } = await TrainOrderInteractor.getChangeListByOrderId(this.id)
      this.changeList = data
    },
    async getRefundList() {
      let { data } = await TrainOrderInteractor.getRefundListByOrderId(this.id)
      this.refundList = data
    }
  }
}
</script>

<style lang="less">
.relate-order {
  .refund-list {
    margin-top: 5px;
    padding: 10px 16px;
    border-radius: 4px;
    overflow: hidden;
    background-color: @color-text-white;
  }
}
</style>
